import { InvoiceStatus, type Invoice } from '@/types/models';

/** Badge colour for a fully written-off invoice. */
export const WRITTEN_OFF_COLOR = '#6d4c41';

/**
 * A "paid" invoice whose lines were settled entirely by write-offs (#682). The stored status
 * stays `paid` — write-off credits count as settled — so this is a display distinction only.
 */
export const isWrittenOffInvoice = (inv: Pick<Invoice, 'status' | 'totalCents' | 'writtenOffCents'>): boolean =>
	inv.status === InvoiceStatus.Paid && inv.totalCents > 0 && (inv.writtenOffCents ?? 0) >= inv.totalCents;

/** What the owner actually PAID: `paidCents` counts write-offs as settled, so take them out. */
export const paidOnlyCents = (inv: Pick<Invoice, 'paidCents' | 'writtenOffCents'>): number =>
	Math.max(0, inv.paidCents - (inv.writtenOffCents ?? 0));
